if (process.env.VUE_APP_BUILD_TARGET !== 'app') {
  require('./main-web')
} else {
  require('./main-app')
}

